import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "card reports-conversions"
}
const _hoisted_3 = { class: "reports-container" }
const _hoisted_4 = {
  key: 0,
  class: "reports-container-table"
}
const _hoisted_5 = { class: "report-table" }
const _hoisted_6 = { class: "container-table-project" }
const _hoisted_7 = { class: "container-project" }
const _hoisted_8 = { class: "container-table-conversion" }
const _hoisted_9 = { class: "container-conversion" }
const _hoisted_10 = { class: "table-bold" }
const _hoisted_11 = {
  key: 1,
  class: "report-no-data"
}
const _hoisted_12 = { class: "reports-container" }
const _hoisted_13 = {
  key: 0,
  class: "reports-container-table"
}
const _hoisted_14 = { class: "report-table" }
const _hoisted_15 = { class: "container-table-project" }
const _hoisted_16 = { class: "container-project" }
const _hoisted_17 = { class: "container-table-conversion" }
const _hoisted_18 = { class: "container-conversion" }
const _hoisted_19 = { class: "table-bold" }
const _hoisted_20 = {
  key: 1,
  class: "report-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "table-title" }, [
          _createElementVNode("h2", { class: "title-main" }, "Conversion Rates")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "table-total" }, [
            _createElementVNode("span", { class: "label-text-conversion" }, "Leads"),
            _createElementVNode("span", { class: "label-text-separation" }, ":"),
            _createElementVNode("span", { class: "label-text-conversion" }, "Holds")
          ], -1)),
          ($setup.conversionsLeadsReports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Project"),
                          _createElementVNode("th", null, "Leads Created"),
                          _createElementVNode("th", null, "Holds Approved")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conversionsLeadsReports, (conversionForEstate, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(conversionForEstate.estate), 1),
                            _createElementVNode("td", null, _toDisplayString(conversionForEstate.leadsToEois.totalLeads), 1),
                            _createElementVNode("td", null, _toDisplayString(conversionForEstate.leadsToEois.leadsToEois), 1)
                          ]))
                        }), 128)),
                        _cache[0] || (_cache[0] = _createElementVNode("tr", { "empty-row": "" }, [
                          _createElementVNode("td", {
                            class: "td-spacing",
                            colspan: "3"
                          })
                        ], -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "table-bold conversion-center" }, "Conversion Rate")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conversionsLeadsReports, (conversionForEstate, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_10, _toDisplayString(conversionForEstate.leadsToEois.conversionRate) + " %", 1)
                          ]))
                        }), 128)),
                        _cache[2] || (_cache[2] = _createElementVNode("tr", { "empty-row": "" }, [
                          _createElementVNode("td", {
                            class: "td-spacing",
                            colspan: "1"
                          })
                        ], -1))
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
              ]))]))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "table-total" }, [
            _createElementVNode("span", { class: "label-text-conversion" }, "Holds"),
            _createElementVNode("span", { class: "label-text-separation" }, ":"),
            _createElementVNode("span", { class: "label-text-conversion" }, "Contracts Signed")
          ], -1)),
          ($setup.conversionsLeadsReports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("table", _hoisted_16, [
                      _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Project"),
                          _createElementVNode("th", null, "Holds Approved"),
                          _createElementVNode("th", null, "Contracts Signed")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conversionsLeadsReports, (conversionForEstate, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(conversionForEstate.estate), 1),
                            _createElementVNode("td", null, _toDisplayString(conversionForEstate.eoisToContractExecutedLots.totalEois), 1),
                            _createElementVNode("td", null, _toDisplayString(conversionForEstate.eoisToContractExecutedLots.eoisToContractExecutedLots), 1)
                          ]))
                        }), 128)),
                        _cache[6] || (_cache[6] = _createElementVNode("tr", { "empty-row": "" }, [
                          _createElementVNode("td", {
                            class: "td-spacing",
                            colspan: "3"
                          })
                        ], -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                      _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "table-bold conversion-center" }, "Conversion Rate")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conversionsLeadsReports, (conversionForEstate, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_19, _toDisplayString(conversionForEstate.eoisToContractExecutedLots.conversionRate) + " %", 1)
                          ]))
                        }), 128)),
                        _cache[8] || (_cache[8] = _createElementVNode("tr", { "empty-row": "" }, [
                          _createElementVNode("td", {
                            class: "td-spacing",
                            colspan: "1"
                          })
                        ], -1))
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
              ]))]))
        ])
      ]))
}